// extracted by mini-css-extract-plugin
export default {"managerContainer":"Manager_managerContainer__5VD+f"};